import { createContext } from 'react';
import { TIME_ZONE } from './time';

/** Display only; reporting boundaries remain in the organization's time zone. */
export const DisplayTimezoneContext = createContext(TIME_ZONE);
